import { render, staticRenderFns } from "./NixiaWelcome.vue?vue&type=template&id=2a46666b&scoped=true&"
import script from "./NixiaWelcome.vue?vue&type=script&lang=js&"
export * from "./NixiaWelcome.vue?vue&type=script&lang=js&"
import style0 from "./NixiaWelcome.vue?vue&type=style&index=0&id=2a46666b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46666b",
  null
  
)

export default component.exports